import React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import { TextField } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function MainEquipment(props) {
    const { t } = useTranslation("translation");
    return (
        <Autocomplete
            id="esp_MainEquipment"
            value={props.selectedMainEquipmentName == null ? "" : props.selectedMainEquipmentName}
            onChange={(_event, newValue) => {
                props.handleMainEquipmentChange(newValue);
            }}
            options={props.mainEquipmentData.map((option) => option.name)}
            renderInput={(params) => <TextField required={props.isRequired} {...params} margin="normal" label={t("MainEquipment")} variant="outlined" />}
        />
    );
}
